// src/features/dashboard/services/Employee/topApplications.service.ts

import apiClient from '../../../../api/apiService';

import {
  ENDPOINTS,
} from '../../../../api/endpoints';

import type {
  TopApplicationsRequest,
  TopApplicationsResponse,
} from '../../types/Employee/topApplications.types';

export const getTopApplications = async (
  payload: TopApplicationsRequest,
): Promise<TopApplicationsResponse> => {

  const response = await apiClient.post(
    ENDPOINTS.EMPLOYEE_TOP_APPLICATIONS,
    payload,
  );

  console.log(
    'Response Data Top:',
    response.data,
  );

  return response.data;
};